export function replaceSpecialSymbols(str) {
  return str
    .replace(/[^a-zA-Z0-9]+/g, '-') // replace special chars with "-"
    .replace(/^-+|-+$/g, ''); // trim leading/trailing "-"
}
